import { Button, FieldText, FlexBox } from '@dixa/lib-shared-habla';
import { useCollectionId } from 'articleEditor/hooks/useCollectionId';
import { useLangId } from 'articleEditor/hooks/useLangId';
import {
  floatingLinkActions,
  submitFloatingLink,
  useFloatingLinkSelectors,
} from 'lib-knowledge-document-structure';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { useCallback, useRef } from 'react';

import { ArticleLinkLookup, LookupArticle } from './articleLinkLookup';
import s from './editLinkTabs.module.scss';

export const EditArticleLinkForm = (): JSX.Element => {
  const collectionId = useCollectionId();
  const languageId = useLangId();
  const isReadOnly = !collectionId;

  const editor = useMyEditorRef();
  const text = useFloatingLinkSelectors().text();
  const articleTitle = useFloatingLinkSelectors().interlinkTitle();

  const setArticle = useCallback(
    (newArticle: LookupArticle | null) => {
      floatingLinkActions.interlinkId(newArticle?.id ?? '');
      floatingLinkActions.interlinkTitle(newArticle?.title ?? '');
      floatingLinkActions.interlinkLangId(languageId ?? '');
    },
    [languageId],
  );

  const textRef = useRef<HTMLInputElement>(null);
  const isFormValid = text.length > 0 && !!articleTitle;

  return (
    <div>
      <ArticleLinkLookup
        collectionId={collectionId}
        languageId={languageId}
        articleTitle={articleTitle}
        onSelect={setArticle}
        readOnly={isReadOnly}
      />

      <FieldText
        readOnly={isReadOnly}
        label="Text"
        className={s['field']}
        input={{
          value: text,
          name: 'text',
          onChange: (e) => floatingLinkActions.text(e?.target.value || ''),
          // @ts-expect-error Habla's typedefs are wrong, it is an InputElement
          ref: textRef,
        }}
      />

      <FlexBox justifyContent="end" gap="200">
        <Button variant="secondary" onClick={() => floatingLinkActions.hide()}>
          Cancel
        </Button>

        <Button
          disabled={!isFormValid || isReadOnly}
          onClick={() => submitFloatingLink(editor)}
        >
          Save
        </Button>
      </FlexBox>
    </div>
  );
};
